/**
 * @flow
 */
import Add from '@mui/icons-material/Add';
import { Button, MenuItem, MenuList, Popover, SvgIcon, Tooltip, Typography } from '@mui/material';
import QuestionTypeIcon from 'components/@home/drawers/FormDrawer/QuestionTypeIcon';
import questionTypes from 'components/@home/drawers/FormDrawer/questionTypes';
import React, { useEffect, useRef, useState } from 'react';
import { I18n } from 'utils/i18n';

type Props = {
  onAddQuestion: Function,
  isEmpty?: boolean,
  disabled?: boolean,
  initiallyOpen?: boolean,
};

const AddQuestionButton = ({
  onAddQuestion,
  isEmpty = false,
  disabled = false,
  initiallyOpen = false,
}: Props) => {
  const anchorEl = useRef();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setOpen(initiallyOpen), 500);
  }, [initiallyOpen]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClick = () => {
    setOpen(true);
  };
  const addQuestion = type => () => {
    onAddQuestion(type);
    handleClose();
  };
  return (
    <>
      <Button
        aria-controls="new-question-menu"
        aria-haspopup="true"
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        ref={anchorEl}
        disabled={disabled}
      >
        <SvgIcon sx={{ mr: 1, color: 'primary.main' }}>
          <Add />
        </SvgIcon>
        {I18n.t(`FormDrawer.Add ${isEmpty ? 'first' : 'new'} question`)}
      </Button>

      <Popover
        id="new-question-menu"
        anchorEl={anchorEl.current}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 270,
              py: '5px',
              px: 0,
            },
          },
        }}
      >
        <MenuList disablePadding>
          {questionTypes.map(type => (
            <Tooltip
              key={type}
              slotProps={{
                tooltip: {
                  sx: theme => ({
                    ml: '5px',
                    backgroundColor: theme.palette.secondary.darker,
                  }),
                },
                arrow: {
                  sx: theme => ({
                    color: theme.palette.secondary.darker,
                  }),
                },
              }}
              title={
                <Typography
                  sx={theme => ({
                    fontSize: 12,
                    padding: '4px',
                    color: theme.palette.white,
                  })}
                >
                  {I18n.t(`FormDrawer.QuestionTypes.${type}.tooltip`)}
                </Typography>
              }
              placement="right"
              arrow
            >
              <MenuItem onClick={addQuestion(type)}>
                <QuestionTypeIcon type={type} sx={{ mr: 1 }} />
                <Typography>{I18n.t(`FormDrawer.QuestionTypes.${type}.title`)}</Typography>
              </MenuItem>
            </Tooltip>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};

export default AddQuestionButton;
